// extracted by mini-css-extract-plugin
module.exports = {"main-container":"Products_main-container__1ABIw","aside":"Products_aside__1aVHm","main":"Products_main__-Q9QM"};